import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { FaCheck, FaFileImage, FaFilePdf } from 'react-icons/fa';
import axios from 'axios';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { RiDeleteBin6Line } from 'react-icons/ri';

const ApplyLeave = ({setLoading, userData}) => {
  const [date, setDate] = useState('');
  const [leavefrom, setLeaveFrom] = useState('');
  const [leaveTo, setLeaveTo] = useState('');
  const [leaveType, setLeaveType] = useState('');
  const [reason, setReason] = useState('');
  const [leaveList, setLeaveList] = useState([]);
  const [file, setFile] = useState(null);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [leaveDefine, setLeaveDefine] = useState([]);
const [showDelete, setShowDelete] = useState(false);
const [selectedLeave, setSelectedLeave] = useState('');


          const fetchMyLeaves = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-apply-leave');
      
                      if (response.ok) {
                          const data = await response.json();
let filteredData = data;

if (userData.role !== 'SupAdmin') {
  filteredData = data.filter(item => item.added_by == userData.user_id);
}
                          setLeaveList(filteredData);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }



  // Fetch leave define on component mount
  useEffect(() => {
    const fetchLeaveDefined = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcian.in/get-leave-define');
        if (response.ok) {
          const data = await response.json();
          setLeaveDefine(data);
        } else {
          console.error('Failed to fetch leave define');
        }
      } catch (error) {
        console.error('Error fetching leave define:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaveDefined();
    fetchMyLeaves();
  }, []);

  // File validation on select
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      setFile(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(selectedFile.type)) {
      alert('Only PDF and image files (jpeg, png, gif) are allowed');
      e.target.value = null;
      return;
    }

    const maxSizeInBytes = 2 * 1024 * 1024; // 2MB
    if (selectedFile.size > maxSizeInBytes) {
      alert('File size must not exceed 2 MB');
      e.target.value = null;
      return;
    }

    setFile(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!leaveType || !leavefrom || !leaveTo || !date) {
      alert('Please fill all required fields');
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('apply_on', date);
      formData.append('define_id', leaveType);
      formData.append('leave_from', leavefrom);
      formData.append('leave_to', leaveTo);
      formData.append('reason', reason);
      formData.append('added_by', userData.user_id);
      formData.append('role', userData.role);
      if (file) formData.append('file', file);

      const response = await axios.post('https://api.kcian.in/apply-leave', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        setResponse2({ message: 'Leave Applied Successfully.', status: 'success' });

fetchMyLeaves();
        setDate('');
        setLeaveType('');
        setLeaveFrom('');
        setLeaveTo('');
        setReason('');
        setFile(null);
        document.getElementById('myFile').value = null;
      } else {
        setResponse2({ message: 'Something went wrong. Please try again.', status: 'error' });
      }
    } catch (error) {
      console.error(error);
      setResponse2({ message: 'Error submitting leave application.', status: 'error' });
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };


    const handleShowDelete = (leave) => {
    setSelectedLeave(leave);
    setShowDelete(true);
  }



                const handleDelete = async (lId) => {
                    setLoading(true);

    try {
      const response = await fetch(`https://api.kcian.in/delete-apply-leave/${lId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setLeaveList((prevData) => prevData.filter((product) => product.id !== lId));
        setShowDelete(false);
        setResponse2({ message: 'Leave Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting:', error);
    } finally {
                            setLoading(false);
    }
  };


      const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} `;
    };

  return (
    <>
      <section className="py-4">
        <div className="px-4">
          <HeadingArea message1="Leave" message2="Apply Leave" />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-5 col-12 my-2">
              <div className="profile-card">
                <p className="profile-heading">Add Apply Leave</p>
                <form className="mt-4" onSubmit={handleSubmit}>
                  <div className="profile-input-area mb-4">
                    <label htmlFor="applyDate" className="profile-badge">
                      Apply Date*
                    </label>
                    <input
                      type="date"
                      id="applyDate"
                      className="profile-input"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      required
                    />
                  </div>

                  <div className="profile-input-area mb-4">
                    <label className="profile-badge">Leave Type*</label>
                    <select
                      className="profile-input"
                      value={leaveType}
                      onChange={(e) => setLeaveType(e.target.value)}
                      required
                    >
                      <option value="">Select Type</option>
                      {leaveDefine.length > 0 ? (
                        leaveDefine.map((leave) => (
                          <option key={leave.id} value={leave.id}>
                            {leave.leave_type || 'Unnamed Leave'}
                          </option>
                        ))
                      ) : (
                        <option disabled>Loading leave types...</option>
                      )}
                    </select>
                  </div>

                  <div className="profile-input-area mb-4">
                    <label htmlFor="leaveFrom" className="profile-badge">
                      Leave From*
                    </label>
                    <input
                      type="date"
                      id="leaveFrom"
                      className="profile-input"
                      value={leavefrom}
                      onChange={(e) => setLeaveFrom(e.target.value)}
                      required
                    />
                  </div>

                  <div className="profile-input-area mb-4">
                    <label htmlFor="leaveTo" className="profile-badge">
                      Leave To*
                    </label>
                    <input
                      type="date"
                      id="leaveTo"
                      className="profile-input"
                      value={leaveTo}
                      onChange={(e) => setLeaveTo(e.target.value)}
                      required
                    />
                  </div>

                  <div className="profile-input-area mt-2 mb-4">
                    <label htmlFor="reason" className="profile-badge">
                      Reason*
                    </label>
                    <textarea
                      id="reason"
                      className="profile-input"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      required
                    />
                  </div>

                  <div className="profile-input-area mb-4">
                    <label htmlFor="myFile" className="profile-badge">
                      File
                    </label>
                    <input
                      type="file"
                      id="myFile"
                      name="uploadedFile"
                      accept=".pdf,image/*"
                      className="profile-input"
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className="text-center mb-4">
                    <button className="profile-btn">
                      <FaCheck /> SAVE
                    </button>
                  </div>

                  {/* Response message */}
                  {response2.message && (
                    <div
                      className={`alert ${
                        response2.status === 'success' ? 'alert-success' : 'alert-danger'
                      }`}
                      role="alert"
                    >
                      {response2.message}
                    </div>
                  )}
                </form>
              </div>
            </div>

            <div className="col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100">
              <div className="profile-card">
                <div className="d-md-flex d-sm-flex justify-content-between mb-2">
                  <span className="profile-heading align-content-center">Leave List</span>

                  {/* <div className="profile-input-area ms-auto col-lg-3 border-0">
                    <input
                      type="text"
                      name="search"
                      className="profile-input border-bottom rounded-0"
                      placeholder="Search..."
                    />
                  </div> */}
                </div>

                <div className="table-responsive">
                  <table className="w-100">
                    <thead className="account-thead">
                        <th className="rounded-start-4">S No</th>
                        <th>Apply On</th>
                        <th>Type</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Reason</th>
                        <th>Attachment</th>
                        <th>Status</th>
                        <th className="rounded-end-4">Action</th>
                    </thead>

                    <tbody>
                      {leaveList.length === 0 ? (
                        <tr className="account-tr text-center">
                          <td colSpan="9">No leaves applied yet.</td>
                        </tr>
                      ) : (
                        leaveList.map((leave, index) => (
                          <tr key={index} className="account-tr">
                            <td>{index + 1}</td>
                            <td>{formatDate(leave.apply_on)}</td>
                            <td>{leave.leave_type}</td>
                            <td>{formatDate(leave.leave_from)}</td>
                            <td>{formatDate(leave.leave_to)}</td>
                            <td>{leave.reason}</td>
                                                                        <td>
                                                {leave.file ? (() => {
                                                    // Extract file extension
                                                    const ext = leave.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${leave.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                            <td>{leave.status}</td>
                            
                                            <td>{leave.status == 'Pending' ? 
                                            <RiDeleteBin6Line className='account-icon1' title='Remove' onClick={() => handleShowDelete(leave)} />
                                            : '--'}
                                                </td>                                  
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Leave!</p>

<div className='table-responsive'>
<table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>Apply On</th>
                        <th>Type</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Reason</th>
                        <th>Attachment</th>
                                        <th className='rounded-end-4'>Status</th>
                                    </thead>

<tr className='account-tr'>
                            <td>{formatDate(selectedLeave.apply_on)}</td>
                            <td>{selectedLeave.leave_type}</td>
                            <td>{formatDate(selectedLeave.leave_from)}</td>
                            <td>{formatDate(selectedLeave.leave_to)}</td>
                            <td>{selectedLeave.reason}</td>
                                                                        <td>
                                                {selectedLeave.file ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedLeave.file.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedLeave.file}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                            <td>{selectedLeave.status}</td>
</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Applied Leave will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedLeave.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}


    </>
  );
};

export default ApplyLeave;
